// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2i5ZC","signatureButtonsRight":"ModalSign_signatureButtonsRight__3tHUB"};